import React, { useState } from 'react';
import Style from './Style.module.css';
import Header from '../../../Components/AdminComponents/Header/Header';
import Sidebar from '../../../Components/AdminComponents/Sidebar/Sidebar';
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import adminInstance from '../../../instance/AdminInstance';
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

const MobileAdsForm = ({ title }) => {
  const navigate = useNavigate();
  const [File, SetFile] = useState({
    File: "",
    FileUrl: "",
    Caption: "",
   
  });

  const uploadFile = (e) => {
    if (e.target.files !== null) {
      SetFile({
        ...File,
        FileUrl: URL.createObjectURL(e.target.files[0]),
        File: e.target.files[0]
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    SetFile({
      ...File,
      [name]: value
    });
  };

  const HandleSubmit = (e) => {
    e.preventDefault();

    // Validation
    if (!File.File) {
      toast.error("Please select an image");
      return;
    }

    let data = new FormData();
    data.append("file", File.File);
   

    adminInstance
      .post("/api/mobile_carousel/upload_mobile_carousel", data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((Response) => {
        toast.success("Mobile carousel uploaded successfully!");
        navigate('/admin/mob_ads');
        SetFile({
          File: "",
          FileUrl: "",
          Caption: "",
         
        });
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Something went wrong");
        console.error(err);
      });
  };

  const HandleCancel = (e) => {
    e.preventDefault();
    SetFile({
      File: "",
      FileUrl: "",
      Caption: "",
      
    });
    navigate('/admin/mob_ads');
  };

  return (
    <div className={Style.new}>
      <Sidebar />
      <div className={Style.newContainer}>
        <Header />
        <div className={Style.top}>
          <h1> "Add Mobile Carousel"</h1>
        </div>
        <div className={Style.bottomTable}>
          <div className={Style.leftItem}>
            <img
              src={
                File.FileUrl
                  ? File.FileUrl
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt="Carousel Preview"
              className={Style.SquareImg}
            />
          </div>
          <div className={Style.right}>
            <form onSubmit={(e) => HandleSubmit(e)}>
              {/* File Upload */}
              <div className={Style.formItem}>
                <label htmlFor="file">
                  Image: <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  accept="image/*"
                  onChange={uploadFile}
                  style={{ display: "none" }}
                />
              </div>

              {/* Title Input */}
             

              {/* Subtitle Input */}
          

              {/* Form Buttons */}
              <div className={Style.formBtn}>
                <button type="submit">Save</button>
                <button type="button" onClick={(e) => HandleCancel(e)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAdsForm;